import { forwardRef } from 'react';
import { Icon } from './icon';
import type { IconProps } from './icon';
import type { Ref } from 'react';
export const Copyright = forwardRef(function Copyright(props: IconProps, ref: Ref<SVGSVGElement>) {
  return (
    <Icon {...props} ref={ref}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0Zm8.139-4.75C9.307 7.25 7.25 9.397 7.25 12s2.057 4.75 4.639 4.75a4.552 4.552 0 0 0 2.792-.956c.35-.271.662-.592.925-.951a.75.75 0 1 0-1.212-.885 3.22 3.22 0 0 1-.63.649 3.052 3.052 0 0 1-1.875.643c-1.714 0-3.139-1.435-3.139-3.25s1.425-3.25 3.139-3.25c.702 0 1.35.238 1.875.643.238.184.45.403.63.649a.75.75 0 1 0 1.212-.885 4.718 4.718 0 0 0-.925-.95 4.552 4.552 0 0 0-2.792-.957Z"
        fill="currentColor"
      />
    </Icon>
  );
});
